import { render, staticRenderFns } from "./xizaokaSee.vue?vue&type=template&id=12f3b847&scoped=true&"
import script from "./xizaokaSee.vue?vue&type=script&lang=js&"
export * from "./xizaokaSee.vue?vue&type=script&lang=js&"
import style0 from "./xizaokaSee.vue?vue&type=style&index=0&id=12f3b847&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f3b847",
  null
  
)

export default component.exports